
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"fill":"#FFF","d":"M-62-181h1440v812H-62z"}}),_c('path',{attrs:{"fill":"#FFF","d":"M-62-120h269v751H-62z"}}),_c('g',{attrs:{"transform":"translate(-8 -8)"}},[_c('rect',{attrs:{"stroke":"#DADADA","fill":"#FFF","x":".5","y":".5","width":"199","height":"33","rx":"2"}}),_c('path',{attrs:{"d":"M24.779 26c.615 0 1.05-.473 1.05-1.08 0-.283-.094-.549-.302-.757l-4.46-4.47a7.253 7.253 0 001.496-4.412C22.563 11.276 19.287 8 15.28 8 11.276 8 8 11.276 8 15.281c0 4.006 3.276 7.282 7.281 7.282 1.582 0 3.04-.511 4.233-1.364l4.488 4.489c.208.208.483.312.777.312zm-9.498-5.009c-3.124 0-5.71-2.585-5.71-5.71 0-3.124 2.586-5.71 5.71-5.71 3.125 0 5.71 2.586 5.71 5.71 0 3.125-2.585 5.71-5.71 5.71z","fill":"#888","fill-rule":"nonzero"}})])])])
          )
        }
      }
    